// Copyright (c) 2017 Deere & Company

import actions from '../../action-list';
import moment from 'moment';

export const resetAllFacets = (facets, claimSettings) => ({
    claimDateRange: {
        from: moment.utc().subtract(claimSettings.numberOfDays, 'days').startOf('day')
            .valueOf(),
        to: moment.utc().endOf('day').valueOf()
    },
    claimStatus: facets.claimStatusFacet.allowedStatus,
    dateType: facets.dateTypeFacet.key,
    dealerAccounts: facets.dealerAccountsFacet.allowedDealers,
    type: actions.RESET_ALL_CLAIMS_FILTERS
});

export const updateDateRangeFacet = dateRange => ({
    dateRange,
    type: actions.UPDATE_ALL_CLAIMS_DATE_RANGE_FACET
});

export const updateDateType = (dateType, dateTypeCollection) => ({
    dateType,
    dateTypeCollection,
    type: actions.UPDATE_ALL_CLAIMS_DATE_TYPE
});

export const selectAllDealersOnInitialLoad = allowedDealers =>
    dispatch => {

        dispatch({
            allowedDealers,
            type: actions.SELECT_ALL_CLAIMS_DEALER_ACCOUNT_FACET_ITEMS
        });

        dispatch({
            allowedDealers,
            type: actions.SELECT_DEALER_INVOICE_DEALER_ACCOUNT_FACET_ITEMS
        });

    };

export const selectAllClaimStatusOnInitialLoad = allowedStatus => ({
    allowedStatus,
    type: actions.SELECT_ALL_CLAIMS_CLAIM_STATUS_FACET_ITEMS
});

export const selectDateOnInitialLoad = days =>
    dispatch => {

        const dateRange = {
            from: moment.utc().subtract(days, 'days').startOf('day')
                .valueOf(),
            to: moment.utc().endOf('day').valueOf()
        };

        dispatch({
            dateRange,
            type: actions.UPDATE_ALL_CLAIMS_DATE_RANGE_FACET
        });

    };

export const toggleDealerAccountFacetItems = allowedDealers => ({
    allowedDealers,
    type: actions.TOGGLE_ALL_CLAIMS_DEALER_ACCOUNT_FACET_ITEMS
});

export const toggleClaimStatusFacetItems = allowedStatus => ({
    allowedStatus,
    type: actions.TOGGLE_ALL_CLAIMS_CLAIM_STATUS_FACET_ITEMS
});

export const updateDealerAccountFacetInput = value => ({
    type: actions.UPDATE_ALL_CLAIMS_DEALER_ACCOUNT_FACET_INPUT,
    value
});

export const updateDealerAccountFacetItem = (dealerAccount, isSelected) => ({
    dealerAccount,
    isSelected,
    type: actions.UPDATE_ALL_CLAIMS_DEALER_ACCOUNT_FACET_ITEM
});

export const updateClaimStatusFacetItem = (claimStatus, isSelected) => ({
    claimStatus,
    isSelected,
    type: actions.UPDATE_ALL_CLAIMS_CLAIM_STATUS_FACET_ITEM
});




// WEBPACK FOOTER //
// ./src/claim/all-claims/action-creators/facets.js